<template>
  <div class="history-container">
    <div class="history-header">
      <div class="history-types">
        <div
          v-for="item in types"
          :key="item.label"
          class="type-item"
          :class="{ active: activeType === item.value }"
          @click="typeChangeEvent(item.value)"
        >
          <span>
            {{ $t(item.label) }}
          </span>
        </div>
      </div>
      <div class="currencys">
        <div
          v-for="item in currencyList"
          :key="item"
          class="currency-item"
          :class="{ active: item === checkedCurrency }"
        >
          <span @click="currencyChangeEvent(item)">
            {{ item }}
          </span>
        </div>
      </div>
      <div class="selectors">
        <CustomSelector
          v-if="[0, 1, 2].includes(activeType)"
          v-model="contractNo"
          label="币种"
          :option-list="[{ label: '全部', value: '' }, ...contractNoList]"
          @input="getTableData"
        />
        <CustomSelector
          v-if="[0, 1, 2].includes(activeType)"
          v-model="direction"
          label="方向"
          :option-list="[
            { label: '全部', value: '' },
            { label: '买入', value: 'BULL' },
            { label: '卖出', value: 'BEAR' },
          ]"
          @input="getTableData"
        />
        <CustomSelector
          v-if="[1].includes(activeType)"
          v-model="orderStatus"
          label="状态"
          :option-list="[
            { label: '全部', value: '' },
            { label: '已成交', value: '已成交' },
            { label: '已挂单', value: '已挂单' },
            { label: '已撤单', value: '已撤单' },
          ]"
          @input="getTableData"
        />
        <CustomSelector
          v-if="[3].includes(activeType)"
          v-model="type"
          label="盈亏"
          :option-list="[
            { label: '盈亏', value: 'PROFIT' },
            { label: '转入', value: 'IN' },
            { label: '转出', value: 'OUT' },
          ]"
          @input="getTableData"
        />
      </div>
    </div>
    <HistoryTable
      :key="activeType"
      :columns="columns"
      :loading="tableLoading"
      :list="tableList"
    />

    <div class="page-box">
      <Page
        v-if="total > pageSize"
        :total="total"
        :page-size="pageSize"
        :model-value="pageNo"
        show-sizer
        @on-change="pageNoChangeEvent"
        @on-page-size-change="pageSizeChangeEvent"
        @on-prev="pageNoChangeEvent"
        @on-next="pageNoChangeEvent"
      />
    </div>
  </div>
</template>
<script>
import {
  fetchUserAssets,
  fetchProfitAndLossHistory,
  fetchEntrustHistory,
  fetchDealHistory,
  fetchFundHistory,
  fetchAllContract,
} from '@/api/contract'
import CustomSelector from './components/CustomSelector.vue'
import HistoryTable from './components/HistoryTable.vue'

export default {
  components: {
    CustomSelector,
    HistoryTable,
  },
  data() {
    return {
      contractNo: '',
      direction: '',
      orderStatus: '',
      type: 'PROFIT',
      tableList: [],
      tableLoading: true,
      activeType: 0,
      types: [
        { label: '成交', value: 0 },
        { label: '委托', value: 1 },
        { label: '盈亏', value: 2 },
        { label: '资金明细', value: 3 },
      ],
      currencyList: [],
      contractNoList: [],
      checkedCurrency: '',
      total: 0, // 数据总数
      pageNo: 1, // 当前页
      pageSize: 10, // 每页条数
      params: undefined,
    }
  },
  computed: {
    tableApi() {
      return {
        0: fetchDealHistory,
        1: fetchEntrustHistory,
        2: fetchProfitAndLossHistory,
        3: fetchFundHistory,
      }[this.activeType]
    },
    dataKey() {
      return {
        0: 'tradingRecord',
        1: 'entrustedRecord',
        2: 'statementResPageRes',
        3: 'content',
      }[this.activeType]
    },
    columns() {
      const _columns = [
        [0, 1, 2].includes(this.activeType) && {
          title: this.$t('类别'),
          minWidth: 100,
          render: (h, { row: { direction } }) => {
            const { color, text } = {
              BULL: { color: '#02B999', text: this.$t('买入/做多') },
              BEAR: { color: '#FF3F4A', text: this.$t('卖出/做空') },
            }[direction]
            const style = `color:${color};`
            const attrs = { style }

            return h('span', { attrs }, text)
          },
        },
        [0, 1, 2].includes(this.activeType) && {
          minWidth: 100,
          title: this.$t('名称'),
          render: (h, { row: { contractNo, lever } }) => {
            const style = 'color:#3890F9;'
            const attrs = { style }
            const name = contractNo.split('_')[0].toUpperCase()
            return h('span', { attrs }, `${name} ${lever}X`)
          },
        },
        [0, 1, 2].includes(this.activeType) && {
          minWidth: 220,
          title: this.$t('订单号'),
          key: {
            0: 'orderId',
            1: 'orderSn',
            2: 'statementSn',
          }[this.activeType],
        },
        [0, 1, 2].includes(this.activeType) && {
          minWidth: 100,
          title: {
            0: this.$t('成交价格'),
            1: this.$t('委托价格'),
            2: this.$t('开仓价格'),
          }[this.activeType],
          key: {
            0: 'price',
            1: 'orderPrice',
            2: 'openPrice',
          }[this.activeType],
        },
        this.activeType === 2 && {
          minWidth: 100,
          title: this.$t('平仓价格'),
          key: 'closePrice',
        },
        [0, 1, 2].includes(this.activeType) && {
          minWidth: 100,
          title: {
            0: this.$t('成交数量'),
            1: this.$t('委托数量'),
            2: this.$t('数量'),
          }[this.activeType],
          key: 'amount',
        },
        [0, 1, 2].includes(this.activeType) && {
          minWidth: 100,
          title: {
            0: this.$t('冻结保证金'),
            1: this.$t('冻结保证金'),
            2: this.$t('保证金'),
          }[this.activeType],
          key: {
            0: 'frozenMargin',
            1: 'initMargin',
            2: 'initMargin',
          }[this.activeType],
        },
        [0, 1, 2].includes(this.activeType) && {
          minWidth: 100,
          title: this.$t('手续费'),
          key: {
            0: 'fee',
            1: 'openFee',
            2: 'commissionFee',
          }[this.activeType],
        },
        this.activeType === 2 && {
          minWidth: 100,
          title: this.$t('过夜利息'),
          key: 'holdingFee',
        },
        this.activeType === 2 && {
          minWidth: 130,
          title: `${this.$t('浮动盈亏')}(${this.checkedCurrency})`,
          key: 'settledProfit',
        },
        [0, 1, 2].includes(this.activeType) && {
          minWidth: 100,
          title: this.$t('止盈止损'),
          render: (h, { row }) => {
            let { profitPrice, lossPrice } = row
            profitPrice = +profitPrice || '--'
            lossPrice = +lossPrice || '--'
            return h('span', `${profitPrice}/${lossPrice}`)
          },
        },
        this.activeType === 1 && {
          minWidth: 100,
          title: this.$t('状态'),
          render: (h, { row: { orderStatus } }) => {
            return h('span', this.$t(orderStatus))
          },
        },
        /*eslint-disable */
        ...(this.activeType === 3
          ? [
              {
                title: this.$t('变动前余额'),
                key: 'changeBeforeAlias',
              },
              {
                title: this.$t('收支'),
                key: 'changeNumAlias',
              },
              {
                title: this.$t('变动后余额'),
                key: 'changeAfterAlias',
              },
            ]
          : []),
        /* eslint-enable */
        {
          title: this.$t('时间'),
          minWidth: 120,
          key: {
            0: 'createdDate',
            1: 'createdDate',
            2: 'createdDate',
            3: 'createdTime',
          }[this.activeType],
        },
      ]
      return _columns.filter(Boolean)
    },
  },
  mounted() {
    this.getCurrencyList()
    this.getAllContract()
  },
  methods: {
    pageNoChangeEvent(pageNo) {
      this.pageNo = pageNo
      this.getTableData()
    },
    pageSizeChangeEvent(pageSize) {
      this.pageSize = pageSize
      this.getTableData()
    },
    typeChangeEvent(activeType) {
      this.activeType = activeType
      this.pageNo = 1
      this.pageSize = 10
      this.contractNo = ''
      this.direction = ''
      this.orderStatus = ''
      this.type = 'PROFIT'
      this.getTableData()
    },
    currencyChangeEvent(currency) {
      this.checkedCurrency = currency
      this.pageNo = 1
      this.pageSize = 10
      this.getTableData()
    },
    async getCurrencyList() {
      const data = await fetchUserAssets({ holdStatus: 'HOLDING' })
      this.currencyList = data.map((item) => item.currency)
      if (this.currencyList.length) {
        this.checkedCurrency = this.currencyList[0]
        this.getTableData()
      }
    },
    async getAllContract() {
      const data = await fetchAllContract()
      this.contractNoList = data.map(({ symbol }) => {
        const [coin, currency] = symbol.split('/')
        return {
          label: coin,
          value: `${coin}_${currency}`,
        }
      })
    },
    async getTableData() {
      this.tableLoading = true
      const params = {
        currency: this.checkedCurrency,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        contractNo: this.contractNo || undefined,
        direction: this.direction || undefined,
        orderStatus: this.orderStatus || undefined,
        type: this.activeType === 3 ? this.type : undefined,
      }
      this.params = JSON.stringify(params)

      const data = await this.tableApi(params)
      if (this.params !== JSON.stringify(params)) {
        return
      }
      if (this.activeType === 3) {
        this.tableList = data[this.dataKey]
        this.total = data.totalElements
      } else {
        this.tableList = data[this.dataKey].records
        this.total = data[this.dataKey].total
      }
      this.tableLoading = false
    },
  },
}
</script>
<style scoped lang="less">
.history-container {
  min-height: 100%;
  padding-bottom: 20px;
  min-width: 1310px;
  // .history-header {
  //   position: sticky;
  //   top: 0;
  //   z-index: 9999;
  // }
  .history-types {
    padding-top: 28px;
    padding-left: 48px;
    display: flex;
    background: #e8e8e8;
    .type-item {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #1c1b1b;
      height: 44px;
      line-height: 44px;
      color: #616888;

      padding: 0 24px;
      &:not(:first-child) {
        margin-left: 20px;
      }
      &.active {
        color: #1c1b1b;
        background-color: #fff;
        border-radius: 10px 10px 0px 0px;
      }
      span {
        cursor: pointer;
      }
    }
  }
  .currencys {
    padding: 20px 0 20px 28px;
    display: flex;
    .currency-item {
      padding: 0 20px;
      height: 51px;
      line-height: 51px;
      position: relative;
      span {
        cursor: pointer;
      }
      &.active::after {
        content: '';
        position: absolute;
        width: 36px;
        height: 4px;
        background: #c02e21;
        left: 50%;
        transform: translate(-50%);
        bottom: 10px;
      }
    }
  }
  .selectors {
    margin-top: 8px;
    display: flex;
    padding-left: 48px;
    .custom-selector:not(:first-child) {
      margin-left: 22px;
    }
  }
  .page-box {
    text-align: center;
  }
}
</style>
